import React from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

function PictureCard({ src, linkText, url, alt }) {
  const classes = useStyles();

  return (
    <a className={classes.root} href={url} target="_blank" rel="noopener noreferrer">
      <img className={classes.img} alt={alt} src={src} />

      <div className={classes.cardBottom}>
        <Typography className={classes.cardLink}>{linkText}</Typography>

        <KeyboardArrowRightIcon className={classes.icon} />
      </div>
    </a>
  );
}

const useStyles = makeStyles(theme => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: 239,
      width: 213,
      marginRight: theme.spacing(7),
      borderRadius: theme.spacing(0.25),
      boxShadow: theme.shadows[5],
      cursor: 'pointer',
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(2),
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    cardBottom: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(5.125),
    },
    cardLink: {
      width: 110,
      height: 20,
      fontSize: 14,
      letterSpacing: '0.25px',
      lineHeight: '20px',
      textDecorationLine: 'underline',
      whiteSpace: 'nowrap',
      color: theme.palette.secondary.main,
    },
    img: {
      height: 142,
      width: 213,
    },
    icon: {
      height: 24,
      width: 24,
    },
  };
});

PictureCard.propTypes = {
  src: PropTypes.string,
  linkText: PropTypes.string,
  url: PropTypes.string,
  alt: PropTypes.string,
};

export default PictureCard;
